<template>
  <v-card elevation="2" outlined shaped tile class="my-4">
    <v-card-title>
      <div @click="expand = !expand" :style="{ cursor: 'pointer' }">Assessment (content is controlled by API)</div>
      <div class="ml-2">
        <v-btn icon color="green" @click="moveUp(section.id)">
          <v-icon>mdi-arrow-up-bold-box</v-icon>
        </v-btn>
        <v-btn icon color="red" @click="moveDown(section.id)">
          <v-icon>mdi-arrow-down-bold-box</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-subtitle v-if="expand">
      <div>ID: {{ section.id }}</div>
      <div>Type: {{ section.type }}</div>
      <div>Sort Order: {{ section.sort_order }}</div>
      <div>Children Count: {{ section.children.length }}</div>
    </v-card-subtitle>
    <v-card-text v-if="expand">
      <div class="d-flex flex-wrap">
        <v-flex xs1>
          <img :src="selectIconImageBase64 || section.attributes.icon_url" class="mb-6" style="width: 100%" />
        </v-flex>
        <v-flex xs11 class="pl-4">
          <v-btn fab dark small color="cyan" elevation="1" @click="openImagePicker">
            <v-icon dark>edit</v-icon>
          </v-btn>
          <div class="mt-2">PNG no larger than 1MB</div>
        </v-flex>
        <v-flex xs12 class="mt-2 mb-2">
          <v-text-field label="Title" v-model="section.title" dense></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field label="Description" v-model="section.attributes.description" dense></v-text-field>
        </v-flex>
      </div>
    </v-card-text>
    <v-card-actions v-if="expand">
      <v-btn color="primary" @click="save">Save</v-btn>
    </v-card-actions>
    <input type="file" ref="imageInput" style="display: none" accept="image/*" @change="onSelectFile" />
  </v-card>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import HomeFeedHeroChild from './HomeFeedHeroChild.vue';
import homefeedService from '../../../services/homefeed';
import { srcToBase64 } from '../../../utils/stringUtil';
export default Vue.extend({
  components: {
    HomeFeedHeroChild,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    moveUp: {
      type: Function,
      required: true,
    },
    moveDown: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    expand: false,
    selectIconImageFileName: null,
    selectIconImageBase64: null,
  }),
  methods: {
    openImagePicker() {
      this.$refs.imageInput.click();
    },
    onSelectFile(e) {
      const file = e.target.files[0];
      if (!file) {
        console.error('No file selected');
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        this.selectIconImageFileName = file.name;
        this.selectIconImageBase64 = event.target.result;
      };
      reader.onerror = (error) => {
        console.error('Error reading file:', error);
      };
      reader.readAsDataURL(file);
    },
    async save() {
      const requestBody = {
        title: this.section.title,
        attributes: { description: this.section.attributes.description },
      };
      if (this.selectIconImageBase64) {
        requestBody.attributes.icon_url = {
          image_base64: srcToBase64(this.selectIconImageBase64),
          image_filename: this.selectIconImageFileName,
        };
      }

      await homefeedService.updateSection(this.section.id, requestBody);
      console.log('Successfully updated section ID:', this.section.id);
    },
  },
});
</script>

<style scoped></style>
